import { END_POINTS, ProtectedRequest } from './helper';

const DashboardService = {
  getUsers: () => ProtectedRequest.get(END_POINTS.DASHBOARD.getUsers),
  getFacilityList: () =>
    ProtectedRequest.get(END_POINTS.DASHBOARD.getFacilityList),
  getFacilities: () => ProtectedRequest.get(END_POINTS.DASHBOARD.getFacilities),
  getScenarios: ({
    facility_code,
    client_id,
  }: {
    facility_code: string;
    client_id?: string;
  }) =>
    ProtectedRequest.get(END_POINTS.DASHBOARD.getScenarios, {
      params: { facility_code, client_id },
    }),
  getCompareShiftMapData: (facilityCode: string) =>
    ProtectedRequest.get(
      `${END_POINTS.DASHBOARD.getCompareShiftMapData(facilityCode)}`
    ),
  getScenarioDetail: (scenario: string) =>
    ProtectedRequest.get(
      `${END_POINTS.DASHBOARD.getScenarioDetailData(scenario)}`
    ),
  getShiftCascadeData: (scenario: string) =>
    ProtectedRequest.get(END_POINTS.DASHBOARD.getShiftCascadeData(scenario)),
  updateShift: (
    params: { scenario: string; user_id: string; facility_code: string },
    data: ShiftParam[]
  ) =>
    ProtectedRequest.post(END_POINTS.DASHBOARD.updateShifts, data, {
      params: params,
    }),
  reset: (params: { user_id: string; facility_code: string }) =>
    ProtectedRequest.delete(END_POINTS.DASHBOARD.resetShifts, {
      params: params,
    }),
};

export default DashboardService;
export type ShiftParam = {
  shift_id: number;
  shift_start: string;
  provider_type_name: string;
  shift_length: number;
  provider_count: number;
  status: 'new' | 'update' | 'delete';
};
